import FeaturedStripeComplete from './FeaturedStripeComplete';

export default FeaturedStripeComplete;
